export default __webpack_public_path__ + "static/media/breakfast2.7e4697bf.jpeg";